import React from 'react';
import { createRoot } from 'react-dom/client';

import apolloClient from '@general/graphql/client';
import { VIEWER_QUERY } from '@general/graphql/viewer.graph';
import { get, apiNames } from '@general/api/shared';
import DealMakingModalGlobal, { COOKIE_NAME, setCookie } from './DealMakingModalGlobal';

const START_DATE = new Date('2026-05-14T00:00:00');
const END_DATE = new Date('2027-02-19T23:59:59');

const getCookie = name => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

const initDealMakingModal = async () => {
    const now = new Date();
    if (now < START_DATE || now > END_DATE) return;

    if (getCookie(COOKIE_NAME)) return;

    let recordId;
    try {
        const { data } = await apolloClient.query({ query: VIEWER_QUERY });
        recordId = data?.viewer?.recordId;
    } catch (e) {
        return;
    }
    if (!recordId) return;

    let result;
    try {
        const response = await get(apiNames.TRANSACTION, `members/${recordId}/discount-eligibility`);
        result = response?.data?.data;
    } catch (e) {
        return;
    }
    const nyEvents = (result?.metadata_promos ?? [])
        .flatMap(promo => promo.events ?? [])
        .filter(e => e.code === '2026NY');

    const dealMakingEvents = result?.eligible ? (result?.events ?? []) : [];

    const allEvents = [...nyEvents, ...dealMakingEvents];

    if (allEvents.length === 0) {
        setCookie(COOKIE_NAME, '1', 30);
        return;
    }

    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);
    root.render(<DealMakingModalGlobal eligibleEvents={allEvents} />);
};

initDealMakingModal();
